const styles = theme => ({
  header: {
    color: 'var(--mcg-dark, #002E47)',
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%;' /* 18px */,
  },
  alignment: {
    display: 'flex',
    padding: '4px',
    marginTop: '4px',
    alignItems: 'flex-start',
    gap: '8px',
    alignSelf: 'stretch',
    borderRadius: '6px',
    background: 'var(--mcg-bg, #F4F6F8)',
  },
  linkHeader: {
    display: 'flex',
    gap: '4px',
  },
  tooltip: {
    marginTop: '2px',
    color: '#ABB2BE',
  },
  tooltipText: {
    color: 'var(--mcg-white, #FFF)',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%' /* 18px */,
  },
  fileButton: {
    display: 'flex',
    height: '36px',
    padding: '4px',
    border: '0',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '4px',
    flex: '1 0 0',
    borderRadius: '6px',
    background: 'var(--mcg-bg, #F4F6F8)',
    color: 'var(--mcg-dark, #002E47)',
    fontsize: '12px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '150%' /* 18px */,
    cursor: 'pointer',
  },
  fileButtonDisable: {
    display: 'flex',
    height: '36px',
    padding: '4px',
    border: '0',
    alignItems: 'center',
    gap: '4px',
    flex: '1 0 0',
    borderRadius: '4px',
    background: 'var(--mcg-bg, #F4F6F8)',
    color: 'var(--mcg-dark, #002E47)',
    fontsize: '12px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '150%' /* 18px */,
  },
  textbox: {
    display: 'flex',
    paddingTop: '4px',
    paddingBottom: '4px',
    alignItems: 'flex-start',
    gap: '8px',
    alignSelf: 'stretch',
    borderRadius: '6px',
    width: '232px',
  },
  textboxDisable: {
    display: 'flex',
    background: 'var(--mcg-bg, #F4F6F8)',
    alignItems: 'center',
    paddingRight: '4px',
    paddingLeft: '4px',
    marginTop: '4px',
    marginBottom: '4px',
    gap: '8px',
    alignSelf: 'stretch',
    borderRadius: '6px',
    width: '232px',
  },
  pdfFile: {
    marginTop: '0 !important',
    '& input': {
      padding: '8px 12px',
    },
  },
  button: {
    width: '66.67',
    borderRadius: '4px',
  },
  icon: {
    width: '20px',
    height: '20px',
  },
  row: {
    display: 'grid',
    gap: '4px',
  },
  box: {
    display: 'grid',
    gap: '12px',
  },
  textfield: {
    margin: '0 !important',
  },
  message: {
    color: 'var(--mcg-gray, #919EAB)',
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%',
  },
  iconButtonAdd: {
    display: 'flex',
    width: '36px',
    height: '36px',
    padding: '4px',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '6px',
    border: '1px dashed var(--Gray-Light, #DBDEE3)',
    background: 'var(--mcg-white, #FFF)',
    '&:hover': {
      border: '1px dashed var(--mcg-blue, #015FFB)',
    },
    '&:focus': {
      border: '1px dashed var(--mcg-blue, #015FFB)',
    },
  },
  iconButtonChange: {
    display: 'flex',
    width: '36px',
    height: '36px',
    padding: '4px',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '6px',
    border: '1px solid var(--Gray-Lighter, #E5E7EB)',
    background: 'var(--mcg-white, #FFF)',
    '&:hover': {
      border: '1px solid var(--mcg-blue, #015FFB)',
    },
    '&:focus': {
      border: '1px solid var(--mcg-blue, #015FFB)',
    },
  },
  iconButtonTrash: {
    display: 'flex',
    width: '36px',
    height: '36px',
    padding: '4px',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '6px',
    background: 'var(--mcg-bg, #F4F6F8)',
  },
  boxIconButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flex: '1 0 0',
  },
  boxDelete: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    alignSelf: 'stretch',
    borderRadius: '6px',
  },
  deleteTitle: {
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%' /* 18px */,
    marginLeft: '8px',
  },
  deleteButton: {
    '& hover': {
      color: 'var(--Error, #ED4245)',
    },
  },
  cardRoot: {},
  cardActions: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingLeft: '15px',
    paddingRight: '15px',
  },
  popover: {
    zIndex: '99999 !important',
  },
  pickerBg: {
    position: 'relative',
    boxSizing: 'border-box',
    display: 'flex',
    width: 36,
    height: 36,
    background: '#f2f2f2',
    borderRadius: '10px',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  iconButton: {
    position: 'absolute',
    right: 20,
  },
  pickerSpan: {
    width: 24,
    height: 24,
    borderRadius: '10px',
    background: 'red',
  },
  textRadio: {
    color: 'var(--mcg-dark, #002E47)',
    /* Body/Body 5 */
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%' /* 18px */,
  },
})

export default styles
